import { BookingStatus } from './enums';

// ✅ Shared styles
const COMPLETED_STYLE = Object.freeze({
  color: '#1565C0',
  softColor: 'rgba(21, 101, 192, 0.12)',
});

const CANCELLED_STYLE = Object.freeze({
  color: '#C62828',
  softColor: 'rgba(198, 40, 40, 0.12)',
});

const SUCCESS_STYLE = Object.freeze({
  color: '#2E7D32',
  softColor: 'rgba(46, 125, 50, 0.12)',
});

const WARNING_STYLE = Object.freeze({
  color: '#FFA500',
  softColor: 'rgba(255, 165, 0, 0.12)',
});

const BOOKING_STATUS_APPEARANCE = Object.freeze({
  [BookingStatus.INQUIRY]: Object.freeze({
    color: 'blue',
    softColor: 'rgba(0, 0, 255, 0.08)',
  }),

  // ✅ Success states
  [BookingStatus.ACCEPTED]: SUCCESS_STYLE,
  [BookingStatus.CONFIRMED]: SUCCESS_STYLE,
  [BookingStatus.RESCHEDULE_ACCEPTED]: SUCCESS_STYLE,

  // ✅ Warning states
  [BookingStatus.AWAITING_DETAILS]: WARNING_STYLE,
  [BookingStatus.PENDING]: WARNING_STYLE,
  [BookingStatus.RESCHEDULE_REQUESTED]: WARNING_STYLE,

  [BookingStatus.PENDING_PAYMENT]: Object.freeze({
    color: '#D88B00',
    softColor: 'rgba(216, 139, 0, 0.12)',
  }),

  // ✅ Negative states (ALL unified)
  [BookingStatus.CANCELLED]: CANCELLED_STYLE,
  [BookingStatus.DECLINED]: CANCELLED_STYLE,
  [BookingStatus.RESCHEDULE_DECLINED]: CANCELLED_STYLE,
  [BookingStatus.DISPUTED]: CANCELLED_STYLE,
  [BookingStatus.FAILED_PAYMENT]: CANCELLED_STYLE,
  [BookingStatus.PAYOUT_FAILED]: CANCELLED_STYLE,
  [BookingStatus.PAYOUT_REVERSED]: CANCELLED_STYLE,

  // ✅ Completed / Reviewed (same blue)
  [BookingStatus.COMPLETED]: COMPLETED_STYLE,
  [BookingStatus.REVIEWED]: COMPLETED_STYLE,

  // ✅ Other
  [BookingStatus.REFUNDED]: Object.freeze({
    color: '#E06C00',
    softColor: 'rgba(224, 108, 0, 0.12)',
  }),

  [BookingStatus.ON_HOLD]: Object.freeze({
    color: '#FCA700',
    softColor: 'rgba(252, 167, 0, 0.12)',
  }),

  [BookingStatus.PAID_OUT]: Object.freeze({
    color: '#216E4E',
    softColor: 'rgba(33, 110, 78, 0.12)',
  }),
});

const normalizeStatus = status => String(status || '').trim().toLowerCase();

export const getBookingStatusAppearance = status => {
  return BOOKING_STATUS_APPEARANCE[normalizeStatus(status)] || null;
};

export const getBookingStatusColor = status => {
  return getBookingStatusAppearance(status)?.color || null;
};

export const getBookingStatusStyle = status => {
  const color = getBookingStatusColor(status);
  return color ? { color } : {};
};
